import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import { useAuthStore } from '../store';

const BASE = process.env.REACT_APP_API_URL || (typeof window !== 'undefined' ? window.location.origin : undefined);

let socketInstance = null;

export function useSocket(handlers = {}) {
  const { token } = useAuthStore();
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;

  useEffect(() => {
    if (!token) return;

    if (!socketInstance) {
      socketInstance = io(BASE, {
        auth: { token },
        transports: ['websocket', 'polling'],
        reconnection: true,
        reconnectionDelay: 1000,
      });
    }

    const socket = socketInstance;

    socket.on('connect', () => console.log('Socket connected'));
    socket.on('disconnect', () => console.log('Socket disconnected'));
    socket.on('connect_error', (e) => console.warn('Socket error:', e.message));

    const events = Object.keys(handlersRef.current);
    events.forEach((event) => {
      socket.on(event, (...args) => handlersRef.current[event]?.(...args));
    });

    return () => {
      events.forEach((event) => socket.off(event));
    };
  }, [token]);

  return socketInstance;
}

export function disconnectSocket() {
  socketInstance?.disconnect();
  socketInstance = null;
}
